import React, { useState } from 'react';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import '../../styles/file-drop.css';

/**
 * Campo de fichero con arrastrar y soltar.
 *
 * Envuelve un `<input type="file">` de verdad: el `ref` sigue apuntando al
 * input, así que quien sube no cambia (`inputRef.current.files[0]`). Al soltar
 * un fichero se copia al input con un `DataTransfer`, para que `files` quede
 * exactamente igual que si se hubiera elegido con el diálogo del sistema.
 *
 * Para limpiar el nombre que se muestra después de publicar, el padre cambia la
 * `key` del componente: se remonta con el estado vacío y el input nuevo también.
 */
export default function FileDropField({
  inputRef,
  accept,
  hint,
  dropLabel = 'Arrastra el fichero aquí o haz clic para elegirlo',
}) {
  const [over, setOver] = useState(false);
  const [fileName, setFileName] = useState('');

  const soltar = (event) => {
    event.preventDefault();
    setOver(false);
    const file = event.dataTransfer?.files?.[0];
    if (!file) return;
    if (inputRef.current) {
      // El input es la fuente de la verdad para la subida; el DataTransfer
      // permite rellenarlo sin abrir el diálogo del sistema.
      const dt = new DataTransfer();
      dt.items.add(file);
      inputRef.current.files = dt.files;
    }
    setFileName(file.name);
  };

  return (
    <div
      className={`file-drop${over ? ' file-drop--over' : ''}`}
      onDragOver={(event) => {
        event.preventDefault();
        setOver(true);
      }}
      onDragEnter={(event) => {
        event.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={soltar}
      onClick={() => inputRef.current?.click()}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          inputRef.current?.click();
        }
      }}
    >
      <ArrowUpTrayIcon className="file-drop__icon" aria-hidden="true" />
      <span className="file-drop__title">{fileName || dropLabel}</span>
      {hint && <span className="file-drop__hint">{hint}</span>}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="file-drop__input"
        tabIndex={-1}
        onChange={(event) => setFileName(event.target.files?.[0]?.name || '')}
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
}
